var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKn = function SvgIconKn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.515 20.485q.757.754 1.604 1.348L21.834 5.118a12.1 12.1 0 0 0-2.952-2.951L2.168 18.881q.593.847 1.347 1.604"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M3.514 3.515C-.272 7.3-.998 12.986 1.333 17.502L17.502 1.333C12.986-.997 7.3-.271 3.514 3.515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M20.486 20.485c3.785-3.786 4.512-9.472 2.181-13.988L6.498 22.667c4.516 2.33 10.202 1.603 13.987-2.182"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.63 14.158 1.12.57.889-.889-.197 1.242 1.12.57-1.241.197-.197 1.242-.57-1.12-1.242.197.889-.89zM14.156 7.63l1.12.571.89-.889-.197 1.242 1.12.57-1.242.197-.197 1.242-.57-1.12-1.242.197.889-.89z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconKn;